import React from "react";
import "./header.css";
import CTA from "./CTA";
import ME from "../../assets/me.png";
import HeaderSocials from "./HeaderSocials";

const Header = () => {
  return (
    <header className="header">
      <div className="container header__container">
        <h5 className="text-light">Hey gang, I'm</h5>
        <h1>Giulia Ivan</h1>
        <h4 className="text-light">Design Engineer</h4>
        {/* <h5 className="text-light">
          and I design and building intuitive, user-centered digital experiences
          from concept to code
        </h5> */}
        <CTA />
        <HeaderSocials />

        <div className="me">
          <img src={ME} alt="profile" />
        </div>

        <a
          href="#contact"
          className="scroll__down"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
